import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const IntroLoader = () => {
  const [show, setShow] = useState(() => !sessionStorage.getItem("epg-intro-seen"));

  useEffect(() => {
    if (!show) return;
    sessionStorage.setItem("epg-intro-seen", "1");
    const t = setTimeout(() => setShow(false), 1900);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="intro-loader"
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-canvas"
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
        >
          <div className="grid-lines absolute inset-0" />
          <motion.img
            src="/epg-monogram-dark.png"
            alt="EPG"
            className="relative h-24 w-auto sm:h-32"
            initial={{ opacity: 0, scale: 0.85, y: 12 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          />
          <motion.div
            className="relative mt-8 h-0.5 w-40 overflow-hidden rounded-full bg-line"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <motion.div
              className="h-full rounded-full bg-brand2"
              initial={{ x: "-100%" }}
              animate={{ x: "0%" }}
              transition={{ delay: 0.3, duration: 1.2, ease: "easeInOut" }}
            />
          </motion.div>
          <motion.p
            className="relative mt-5 text-[11px] font-semibold uppercase tracking-[0.3em] text-slate"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.5 }}
          >
            Precision in Every Print
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default IntroLoader;
